const o = (t) => {
  const e = Math.round(t.getCurrentTime()), n = Math.round(t.getDuration());
  return Math.round(e / n * 100);
};
export {
  o as getVideoPercentage
};
